import React from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "../../components/Navbar/Navbar";
import Hero from "../../components/Hero/Hero";
import Footer from "../../components/Footer/Footer";

import aboutUs from "../../assets/images/about.jpg";
import nswTradingLicense from "../../assets/images/nsw-fair-trading.svg";
import memberEngineersAustralia from "../../assets/images/engineers-australia.png";
import masterBuilder from "../../assets/images/master-builders-member.png";
import iCare from "../../assets/images/icare.png";
import buildersCompensationFund from "../../assets/images/builders-compensation-fund.jpg";
import chaseUnderwriting from "../../assets/images/chase-underwriting.png";
import acra from "../../assets/images/acra.png";

import classes from "./About.module.scss";

const credentials = [
  {
    image: nswTradingLicense,
    alt: "NSW Fair Trading licence",
    text: "Building Licence 278427C",
  },
  {
    image: memberEngineersAustralia,
    alt: "Engineers Australia member",
    text: "Member ID: 5064521",
  },
  {
    image: nswTradingLicense,
    alt: "NSW Fair Trading registration",
    text: "Body Corporate Registration BUP0003949",
  },
  {
    image: masterBuilder,
    alt: "Master Builders member",
    text: "Member ID: 3508168",
  },
  {
    image: nswTradingLicense,
    alt: "NSW Fair Trading building practitioner",
    text: "Building Practitioner BUP0001885",
  },
  {
    image: acra,
    alt: "ACRA member",
    text: "Membership Number: 559",
  },
];

const insurances = [
  {
    image: iCare,
    alt: "icare approved provider",
    text: "Approved to undertake works requiring home building compensation",
  },
  {
    image: iCare,
    alt: "icare workers compensation",
    text: "Workers Compensation",
  },
  {
    image: buildersCompensationFund,
    alt: "Home Building Compensation Fund",
    text: "Home Building Compensation Fund",
  },
  {
    image: chaseUnderwriting,
    alt: "Chase Underwriting insurance",
    text: "Public liability and contract works",
  },
];

const About = () => {
  const scrollingCredentials = [...credentials, ...credentials];

  return (
    <div className={classes["about"]}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About | Unified Building Group</title>
        <meta
          name="description"
          content="Learn about Unified Building Group, our experienced remedial building team, licences, memberships and insurance credentials across NSW."
        />
      </Helmet>

      <Navbar />
      <Hero image={aboutUs} title="About us" />

      <main>
        <section className={classes["meet-the-team"]}>
          <div className={classes["section-header"]}>
            <p>Leadership</p>
            <h1>Meet the team</h1>
          </div>

          <div className={classes["team-box-wrapper"]}>
            <article className={classes["team-box"]}>
              <span>Director / Licensed Builder</span>
              <h2>Moji Shariati</h2>
              <p>
                Moji is a civil engineering graduate and licensed builder with
                extensive knowledge in structural concrete repairs. He evaluates
                concrete deterioration, applies appropriate diagnostic methods
                and guides projects with a practical, standards-focused
                approach.
              </p>
            </article>

            <article className={classes["team-box"]}>
              <span>Strata / Remedial Specialist</span>
              <h2>George Farah</h2>
              <p>
                George has extensive experience and a deep understanding of the
                strata industry. He recognises that rectification works require
                care, safety and consideration for residents, with a focus on
                minimising disruption wherever possible.
              </p>
            </article>
          </div>
        </section>

        <section className={classes["our-credentials"]}>
          <div className={classes["section-header"]}>
            <p>Licences & memberships</p>
            <h1>Our Credentials</h1>
          </div>

          <div className={classes["credentials-marquee"]}>
            <div className={classes["credentials-track"]}>
              {scrollingCredentials.map((item, index) => (
                <div
                  className={classes["credential-card"]}
                  key={`${item.text}-${index}`}
                >
                  <img src={item.image} alt={item.alt} />
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className={classes["insurances"]}>
          <div className={classes["section-header"]}>
            <p>Protection & compliance</p>
            <h1>Insurances</h1>
          </div>

          <div className={classes["insurances-logo-container"]}>
            {insurances.map((item) => (
              <article className={classes["img-wrapper"]} key={item.text}>
                <img src={item.image} alt={item.alt} />
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
